import {
    COLOR_OR_TOKEN_PATTERN_WITH_RGBA,
    enhanceOptionsSchemaWithDynamicOptions,
    getPattern,
} from '../utils';

export const markdownOptionsSchema = enhanceOptionsSchemaWithDynamicOptions({
    backgroundColor: {
        description: 'Specify the background color using a Hex code such as "#FF0000".',
        type: 'string',
        default: 'transparent',
        pattern: COLOR_OR_TOKEN_PATTERN_WITH_RGBA,
    },
    customFontSize: {
        description:
            'Specify the font size (in pixels) you would like to use for unformatted text when `fontSize` is set to `custom`. Header elements are calculated with the following formula: h1 = 2 × `customFontSize`, h2 = 1.5 × `customFontSize`, h3 = 1.25 × `customFontSize`',
        default: 14,
        type: 'number',
    },
    fontColor: {
        description:
            'Specify the text color using Hex codes or RGBA values, such as "#FF0000" or "rgba(25,12,13,0.1)". The default for enterprise light is "#3c444d". The default for enterprise dark is "#FFFFFF". The default for prisma dark is "rgba(255, 255, 255, 0.7)".',
        type: 'string',
        default: '> themes.defaultFontColor',
        pattern: COLOR_OR_TOKEN_PATTERN_WITH_RGBA,
    },
    fontFamily: {
        default: 'Splunk Platform Sans',
        pattern: getPattern([
            'Splunk Platform Sans',
            'Splunk Data Sans',
            'Splunk Platform Mono',
            'Arial',
            'Helvetica',
            'Times New Roman',
            'Comic Sans MS',
        ]),
        description:
            'Specify the font family you would like to use for markdown content, such as "Comic Sans MS". Note: the font needs to be available to your end user.',
        type: 'string',
    },
    fontSize: {
        description:
            'Specify the font size you would like to use for markdown content. Font sizes range from extra small (10px for unformatted text) to extra large (18px for unformatted text) with the default being 14px for unformatted text.',
        type: 'string',
        default: 'default',
        pattern: getPattern(['extraSmall', 'small', 'default', 'large', 'extraLarge', 'custom']),
    },
    markdown: {
        description: 'Add text using basic markdown syntax.',
        type: 'string',
    },
    rotation: {
        description: 'Specify the angle of rotation of the markdown content in degrees.',
        type: 'number',
        default: 0,
    },
});
